import { AssignmentStatus } from '../../types/assignment-status';

export const ASSIGNMENT_PROBABILITY_MIN = 1;
export const ASSIGNMENT_PROBABILITY_MAX = 99;
export const DEFAULT_ASSIGNMENT_PROBABILITY = 50;

const ASSIGNMENT_PROBABILITY_WARNING_MIN = 34;
const ASSIGNMENT_PROBABILITY_SUCCESS_MIN = 67;

const PROBABILITY_ELIGIBLE_STATUSES = new Set<AssignmentStatus>([
  AssignmentStatus.Unconfirmed,
  AssignmentStatus.Draft,
]);

export function isAssignmentProbabilityVisible(status: AssignmentStatus): boolean {
  return PROBABILITY_ELIGIBLE_STATUSES.has(status);
}

export function getAssignmentProbabilityClassName(probability: number | null | undefined): string {
  if (probability === null || probability === undefined) return 'text-muted-foreground';
  if (probability >= ASSIGNMENT_PROBABILITY_SUCCESS_MIN) return 'text-success';
  if (probability >= ASSIGNMENT_PROBABILITY_WARNING_MIN) return 'text-warning';
  return 'text-destructive';
}

export function getAssignmentProbabilityIndicatorClassName(
  probability: number | null | undefined
): string {
  if (probability === null || probability === undefined) return 'bg-muted-foreground';
  if (probability >= ASSIGNMENT_PROBABILITY_SUCCESS_MIN) return 'bg-success';
  if (probability >= ASSIGNMENT_PROBABILITY_WARNING_MIN) return 'bg-warning';
  return 'bg-destructive';
}

export function formatAssignmentProbability(probability: number): string {
  return `${probability}%`;
}

export function normalizeProjectProbability(probability: number | null | undefined) {
  if (probability === null || probability === undefined) return null;
  return probability <= 1 ? Math.round(probability * 100) : Math.round(probability);
}

export function getDefaultAssignmentProbability(projectProbability?: number | null): number {
  return normalizeProjectProbability(projectProbability) ?? DEFAULT_ASSIGNMENT_PROBABILITY;
}

export function normalizeAssignmentProbabilityOnBlur(inputValue: string): number | null {
  if (inputValue === '') return null;

  return Math.max(ASSIGNMENT_PROBABILITY_MIN, Number(inputValue));
}
